import {Control, useWatch} from 'react-hook-form';
import {useSelector} from 'react-redux';

import {countSelected} from 'entities/notification';
import {userSelector} from 'entities/user';
import {getNotifyListMode, isFreeTariffPrice} from 'features/http/lib/httpNotifyView';

export const useNotifyChannel = (
    control: Control<any>,
    fieldName: string,
    isLoading: boolean,
    items: unknown[] | undefined,
    withPremium: boolean,
) => {
    const user = useSelector(userSelector);
    const selected = useWatch({control, name: fieldName});

    return {
        mode: getNotifyListMode(withPremium && isFreeTariffPrice(user?.tariff.price), isLoading, items),
        selected,
        checkedCount: countSelected(selected),
    };
};

export default useNotifyChannel;
